import { FirestoreDataConverter } from "firebase/firestore";

import { Cow } from "../../models";

const cowConverter: FirestoreDataConverter<Cow> = {
  toFirestore: (cow) => ({
    cowName: cow.cowName,
    dateOfPurchase: cow.dateOfPurchase,
    purchasePrice: cow.purchasePrice,
    location: cow.location,
    status: cow.status,
    createdAt: cow.createdAt,
    updatedAt: cow.updatedAt,
    calfId: cow.calfId,
    lastVaccineDate: cow.lastVaccineDate,
  }),
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      cowName: data.cowName,
      calfId: data.calfId,
      dateOfPurchase: data.dateOfPurchase,
      purchasePrice: data.purchasePrice,
      location: data.location,
      status: data.status,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      lastVaccineDate: data.lastVaccineDate,
    };
  },
};

export default cowConverter;
